import { Avatar, Col, Dropdown, Menu } from "antd";
import { Logout, User } from "react-iconly";
import { useHistory } from "react-router-dom";
import avatarImg from "../../../assets/images/logo/user.png";
import { useEffect, useState } from "react";
import { FaAccusoft, FaLockOpen, FaUsb, FaUserCheck } from "react-icons/fa";

const HeaderUser = () => {
  const history = useHistory();
  const [usename,setusername]=useState("");
  const [usetype,setusetype]=useState("");
  useEffect(()=>{
    debugger
   let name=sessionStorage.getItem('fullName');
   let usertype=sessionStorage.getItem('userType');
   if(name && usertype){
    setusername(name);
    setusetype(usertype)
   }
  },[])
  const menu = (
    <Menu theme="light">
      
      <Menu.Item
        key={5}
        icon={
          <FaUserCheck
            set="curved"
            className="remix-icon da-vertical-align-middle da-text-color-dark-0"
            size={16}
          />
        }
        className="da-text-color-dark-0"
      >
        {usename}
      </Menu.Item>
       <Menu.Item
        key={5}
        icon={
          <User
            set="curved"
            className="remix-icon da-vertical-align-middle da-text-color-dark-0"
            size={16}
          />
        }
        className="da-text-color-dark-0"
      >
        {usetype}
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          sessionStorage.clear();
          localStorage.removeItem("token");
          history.push("/login");
        }}
        key={5}
        icon={
          <Logout
            set="curved"
            className="remix-icon da-vertical-align-middle da-text-color-dark-0"
            size={16}
          />
        }
        className="da-text-color-dark-0"
        style={{color:'red'}}
      >
        Logout
      </Menu.Item>
    </Menu>
  );

  return (
    <Col>
      <Dropdown overlay={menu} placement="bottomLeft">
        <Col className="da-d-flex-center" onClick={(e) => e.preventDefault()}>
          <Avatar src={avatarImg} size={40} />
        </Col>
      </Dropdown>
    </Col>
  );
};

export default HeaderUser;
